<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { BaseBannerAlert } from '@cplug/design-system'
import { BannerAlertType } from '@cplug/design-system/components/props'
import useStagingAccountActivationStore from '../../stores/useStagingAccountActivationStore'
import { useStagingAccountActivationTranslation } from '../../composables/StagingAccountActivation.i18n'
import { navigateTo } from '#app'
import { useToast } from '~/shared/composables/useToast'

const BLOCKED_PLAN_PATH = '/dashboard/blocked-plan'

const { t } = useStagingAccountActivationTranslation()
const toast = useToast()
const route = useRoute()
const store = useStagingAccountActivationStore()
const { shouldShowBanner } = storeToRefs(store)

onMounted(async () => {
  await store.getStatus()
})

async function onActivate (): Promise<void> {
  if (!await store.activate()) {
    toast.error(store.errors[0]?.message ?? t('StagingActivationError'))
    return
  }

  toast.success(t('StagingActivationSuccess'))

  if (route.path === BLOCKED_PLAN_PATH) {
    await navigateTo('/dashboard', { replace: true })
  }
}
</script>

<template>
  <BaseBannerAlert
    v-if="shouldShowBanner"
    class="mb-4"
    :title="t('StagingActivationTitle')"
    :body-text="t('StagingActivationBody')"
    :type="BannerAlertType.Warning"
    :primary-action-label="t('StagingActivationAction')"
    :primary-action="onActivate"
    :dismiss="false"
  />
</template>
